import { generateGUID } from '@wix/cashier-common/dist/src/utils/guid/generateGUID';
import { win } from '@wix/cashier-common/dist/src/utils/win';
import { type InboundMessageType } from '../../types/InboundMessageType';
import { type OutboundMessageType } from '../../types/OutboundMessageType';
import { messenger } from '../messenger';
import { type EmitReplyMessage, type InboundEmitMessage, type OutboundEmitMessage } from './types';

const maxResponseTimeout = 5000;
const maxSlowMessageResponseTimeout = 30000;

export const enum EmitMessageError {
  Timeout = 'timeout',
}

export const emitMessage = (
  payload: {
    type: InboundMessageType | OutboundMessageType;
    data?: any;
  },
  targetWindow: Window,
  targetOrigin: string,
  isSlowMessage = false,
): Promise<any> =>
  new Promise<any>((resolve, reject) => {
    const messageId: string = generateGUID();

    const handlePostMessage = (event: { data: EmitReplyMessage } & MessageEvent) => {
      if (
        event.source &&
        event.origin &&
        event.source === targetWindow &&
        event.origin === targetOrigin &&
        event.data &&
        event.data.messageId === messageId
      ) {
        clearTimeout(waitId);

        if (event.data.payload?.error) {
          reject(event.data.payload.error);
        } else {
          resolve(event.data.payload);
        }

        removeListener();
      }
    };

    const waitId = setTimeout(
      () => {
        win.removeEventListener('message', handlePostMessage);
        reject({
          message: EmitMessageError.Timeout,
        });
      },
      isSlowMessage ? maxSlowMessageResponseTimeout : maxResponseTimeout,
    );

    const removeListener = messenger.addListener(handlePostMessage, 'emit-message');

    targetWindow?.postMessage(
      {
        messageId,
        payload,
      } as InboundEmitMessage | OutboundEmitMessage,
      targetOrigin,
    );
  });
